/*
Copyright 2024 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const LocationContributionIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Location Contribution',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M2 5v26a1 1 0 0 0 1 1h30a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1Zm4 3h18v14H6Zm0 20v-4h18v4Zm24 0h-4V8h4Z"
    />
    <path
      d="m18.838 10.346-4.988 7.127-2.84-2.573a.5.5 0 0 0-.706.035l-.939 1.038a.5.5 0 0 0 .035.706l3.84 3.476a1.21 1.21 0 0 0 1.8-.2l5.76-8.233a.5.5 0 0 0-.123-.7l-1.147-.8a.5.5 0 0 0-.692.124Z"
    />
  </svg>`;
};
